import React, { useCallback, useEffect, useState } from "react";
import { useAdminApi } from "./useAdminApi";

function QueueTab({ user, onForbidden }) {
  const apiFetch = useAdminApi(user, onForbidden);
  const [items, setItems] = useState(null);
  const [counts, setCounts] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await apiFetch("/admin/pricing-queue?limit=200");
      setItems(data.items);
      setCounts(data.counts);
    } catch (err) {
      if (err.message !== "Forbidden") setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [apiFetch]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div>
      <p className="kicker">eBay sync queue</p>
      <h2 className="admin-title admin-title--left">Pricing sync queue</h2>

      {counts && (
        <div className="admin-price-buckets admin-queue-counts">
          <div className="admin-price-bucket">
            <span className="admin-price-bucket-label">pending</span>
            <span className="admin-price-bucket-value">{counts.pending}</span>
          </div>
          <div className="admin-price-bucket">
            <span className="admin-price-bucket-label">processing</span>
            <span className="admin-price-bucket-value">{counts.processing}</span>
          </div>
          <div className="admin-price-bucket">
            <span className="admin-price-bucket-label">failed</span>
            <span className="admin-price-bucket-value">{counts.failed}</span>
          </div>
        </div>
      )}

      {loading && <p className="admin-status">Loading…</p>}
      {error && <p className="admin-status admin-error">{error}</p>}

      <div className="admin-table glass">
        {items && items.length === 0 && <p className="admin-status">Queue is empty.</p>}
        {items && items.map((item) => (
          <div className="admin-row" key={item._id}>
            <div className="admin-row-main">
              <div className="admin-source-name">{item.title_hint || "Unknown title"}</div>
              <div className="admin-source-meta">
                {item.platform_hint || "—"}
                {item.barcode && <> · <code>{item.barcode}</code></>}
              </div>
              {item.last_error && (
                <div className="admin-status admin-error admin-status--inline admin-queue-error">{item.last_error}</div>
              )}
            </div>
            <div className="admin-row-meta">
              <span className={`admin-queue-status admin-queue-status--${item.status}`}>{item.status}</span>
              <span className="admin-row-id">attempts {item.attempts}</span>
              <span className="admin-row-id">{new Date(item.requested_at).toLocaleString()}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default QueueTab;
